import type { ReactElement } from 'react'

import WysiwygRenderer from '../components/WysiwygRenderer'

const parseDocument = (doc: ReactElement) => {
  return doc?.props?.document?.reduce((acc: any, current: any) => {
    if (current?.children) {
      return acc + current.children?.map((c: any) => c?.text ?? '')?.join('')
    }
  }, '')
}

export const wysiwygTransformer = (
  jsonSource?: string
): ReactElement | null => {
  if (!jsonSource) return null

  let content
  try {
    content = JSON.parse(jsonSource.replace(/\\"/g, '"'))
  } catch (e) {
    return null
  }

  if (content?.length === 0) {
    return null
  }

  const reactNodeOutput = <WysiwygRenderer document={content} />

  if (
    typeof reactNodeOutput.props.document === 'string' ||
    parseDocument(reactNodeOutput) === ''
  ) {
    return null
  } else {
    return reactNodeOutput
  }
}
